import { render } from "./twocolumn.vue?vue&type=template&id=4f56d860"
import script from "./twocolumn.vue?vue&type=script&lang=js"
export * from "./twocolumn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__